<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
<div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
        <vx-card title="Registro del Docente">
            <form enctype="multipart/form-data">
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Cédula</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <vs-input class="w-full" icon-no-border v-model="docente.cedula" />
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <input type="text" v-model="docente.idusuario" hidden>
                    <input type="text" v-model="docente.grupo_idgrupo" hidden>
                    <input type="text" v-model="docente.password" hidden>
                    <input type="text" v-model="docente.fecha_create" hidden>
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Nombres</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <vs-input type="text" class="w-full" icon-pack="feather" icon-no-border v-model="docente.nombre" />
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Apellidos</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <vs-input class="w-full" icon-no-border v-model="docente.apellido" />
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Correo</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <vs-input type="email" class="w-full" icon-no-border v-model="docente.email" />
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Teléfono</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <vs-input type="tel" class="w-full" icon-no-border v-model="docente.telefono" />
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Genero</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <ul class="demo-alignment">
                            <li>
                                <vs-radio v-model="docente.genero" vs-value="0">Hombre</vs-radio>
                            </li>
                            <li>
                                <vs-radio v-model="docente.genero" vs-value="1">Mujer</vs-radio>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Institución</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <v-select :options="institucion" :reduce="institucion => institucion.idinstitucion" label="nombre" v-model="docente.institucion_idinstitucion"></v-select>
                    </div>
                </div>
                <div class="vx-row mb-6 text-center">
                    <div class="vx-col sm:w-1/2 w-full ml-auto">
                        <vs-button color="danger" type="border" class="mb-2" to="/">Salir</vs-button>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full ml-auto">
                        <vs-button color="success" type="border" @click="guardar()" class="mb-2">Enviar</vs-button>
                    </div>
                </div>
            </form>
        </vx-card>
    </div>
</div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import "vue-select/dist/vue-select.css";
import vSelect from "vue-select";
Vue.use(axios)
Vue.component("v-select", vSelect);
export default {
    data() {
        return {
            docente: {},
            institucion: [],
            checkbox_remember_me: false,
        }
    },
    mounted() {
        this.getInstitucion();
    },
    methods: {
        getInstitucion() {
            let me = this;
            me.$http.get(this.$server_url+'institucion')
            // axios.get('http://localhost:8000/api/institucion', {

            //     })
                .then(function (response) {
                    me.institucion = response.data;
                    console.log(me.institucion);
                })
                .catch(function (error) {})
        },
        guardar() {
            let me = this;
            let formData = new FormData();
            formData.append('nombre', me.docente.nombre);
            formData.append('apellido', me.docente.apellido);
            formData.append('cedula', me.docente.cedula);
            formData.append('email', me.docente.email);
            formData.append('telefono', me.docente.telefono);
            formData.append('estado', me.docente.estado);
            formData.append('genero', me.docente.genero);
            formData.append('grupo_idgrupo', 2);
            formData.append('institucion_idinstitucion', me.docente.institucion_idinstitucion);
            me.$http.post(this.$server_url+'docente', formData)
            // axios.post('http://localhost:8000/api/docente', formData)
                .then(function (response) {
                    me.$vs.dialog({
                        color: 'success',
                        title: `Registro Completado`,
                        text: 'Su codigo de acceso fue envia al correo registrado',
                    })
                    me.docente=[]
                })
                .catch(function (error) {})
        }
    },
}
</script>

<style lang="scss">
#page-login {
    .social-login-buttons {
        .bg-facebook {
            background-color: #1551b1
        }

        .bg-twitter {
            background-color: #00aaff
        }

        .bg-google {
            background-color: #4285F4
        }

        .bg-github {
            background-color: #333
        }
    }
}
</style>
